import { IMenuItem } from "@/interfaces";

export const CONSTANTS = {
  PROJECT_TITLE: 'Health4Life Parents & Teens',
  CONTACT_EMAIL: 'info@parentsandteens.org.au',
  LOGO: {
    PATH: '/images/logo.svg'
  },
  MENU: {
    PUBLIC: [
      // { id: 'about', label: 'About', href: '/about-us' },
      { id: 'team', label: 'Team', href: '/team' },
      { id: 'contact', label: 'Contact us', href: '/contact' },
    ] as IMenuItem[],
    PRIVATE: [
      { id: 'dashboard', label: 'Dashboard', href: '/dashboard' },
      { id: 'goals', label: 'Goals', href: '/goals' },
      { id: 'feedback', label: 'Feedback', href: '/feedback' },
      { id: 'resources', label: 'Resources', href: '/resources' },
      { id: 'get-help-now', label: 'Get help now', href: '/get-help-now' },
      { id: 'about-us', label: 'Learn More', href: '/about-us' },
    ] as IMenuItem[]
  },
  USERFLOW: {
    PARENT: {
      ID: 76,
      URL: 'parent',
      STEPS: {
        MODULES: {
          ALCOHOL: {
            ID: 338,
            URL: "alcohol",
            THEME: 'red',
            ICON_URL: '/images/alcohol-icon.svg',
            GOALS: {
              PAGE: {
                ID: 128292
              },
              GOAL: {
                ID: 34802
              },
              METHODS: {
                ID: 35238
              }
            }
          },
          SMOKING: {
            ID: 339,
            URL: "smoking",
            THEME: 'blue',
            ICON_URL: '/images/smoking-vaping-icon.png',
            GOALS: {
              PAGE: {
                ID: 128312
              },
              GOAL: {
                ID: 34831
              },
              METHODS: {
                ID: 35234
              }
            }
          },
          SCREEN_TIME: {
            ID: 340,
            URL: "screen-time",
            THEME: 'green',
            ICON_URL: '/images/screen-time-icon.svg',
            GOALS: {
              PAGE: {
                ID: 128322
              },
              GOAL: {
                ID: 34859
              },
              METHODS: {
                ID: 34865
              }
            }
          },
          HEALTHY_EATING: {
            ID: 341,
            URL: "eating-well",
            THEME: 'yellow',
            ICON_URL: '/images/diet-icon.svg',
            GOALS: {
              PAGE: {
                ID: 128339
              },
              GOAL: {
                ID: 34940
              },
              METHODS: {
                ID: 35243
              }
            }
          },
          PHYSICAL_ACTIVITY: {
            ID: 342,
            URL: "exercise",
            THEME: 'orange',
            ICON_URL: '/images/exercise-icon.svg',
            GOALS: {
              PAGE: {
                ID: 128344
              },
              GOAL: {
                ID: 34953
              },
              METHODS: {
                ID: 34955
              }
            }
          },
          SLEEP: {
            ID: 343,
            URL: "sleep",
            THEME: 'purple',
            ICON_URL: '/images/sleep-icon.svg',
            GOALS: {
              PAGE: {
                ID: 128360
              },
              GOAL: {
                ID: 34985
              },
              METHODS: {
                ID: 34987
              }
            }
          },
          COPING_WITH_STRESS: {
            ID: 344,
            URL: "learning-coping-strategies",
            THEME: 'lime',
            ICON_URL: '/images/coping-icon.svg',
            GOALS: {
              PAGE: {
                ID: 128373
              },
              GOAL: {
                ID: 35030
              },
              METHODS: {
                ID: 35033
              }
            }
          },
        },
        GOALS: {
          ALCOHOL: {
            ID: 348,
            URL: "alcohol-goals",
            MODULE: {
              ID: 338,
            }
          },
          SMOKING: {
            ID: 349,
            URL: "smoking-goals",
            MODULE: {
              ID: 339,
            }
          },
          SCREEN_TIME: {
            ID: 350,
            URL: "screen-time-goals",
            MODULE: {
              ID: 340,
            }
          },
          HEALTHY_EATING: {
            ID: 351,
            URL: "eating-well-goals",
            MODULE: {
              ID: 341,
            }
          },
          PHYSICAL_ACTIVITY: {
            ID: 352,
            URL: "physical-activity-goals",
            MODULE: {
              ID: 342,
            }
          },
          SLEEP: {
            ID: 353,
            URL: "sleep-goals",
            MODULE: {
              ID: 343,
            }
          },
          COPING_WITH_STRESS: {
            ID: 354,
            URL: "coping-with-stress-goals",
            MODULE: {
              ID: 344,
            }
          }
        },
        FEEDBACK: {
          SCREEN_TIME: {
            ID: 355,
            URL: "screen-time-and-social-media-feedback",
            MODULE: {
              ID: 340,
            }
          },
          SMOKING: {
            ID: 356,
            URL: "feedback-smoking-and-vaping",
            MODULE: {
              ID: 339,
            }
          },
          ALCOHOL: {
            ID: 357,
            URL: "alcohol-feedback",
            MODULE: {
              ID: 338,
            }
          },
          SLEEP: {
            ID: 358,
            URL: "sleep-feedback",
            MODULE: {
              ID: 343,
            }
          },
          HEALTHY_EATING: {
            ID: 359,
            URL: "healthy-eating-feedback",
            MODULE: {
              ID: 341,
            }
          },
          PHYSICAL_ACTIVITY: {
            ID: 360,
            URL: "physical-activity-feedback",
            MODULE: {
              ID: 342,
            }
          },
          COPING_WITH_STRESS: {
            ID: 361,
            URL: "coping-with-stress-feedback",
            MODULE: {
              ID: 344,
            }
          },
        },
        SUMMARIES: {
          SCREEN_TIME: {
            ID: 364,
            URL: "screen-time-&-social-media-summary",
            MODULE: {
              ID: 340,
            }
          },
          SMOKING: {
            ID: 365,
            URL: "smoking-summary",
            MODULE: {
              ID: 339,
            }
          },
          ALCOHOL: {
            ID: 366,
            URL: "alcohol-summary",
            MODULE: {
              ID: 338,
            }
          },
          SLEEP: {
            ID: 367,
            URL: "sleep-summary",
            MODULE: {
              ID: 343,
            }
          },
          HEALTHY_EATING: {
            ID: 368,
            URL: "healthy-eating-summary",
            MODULE: {
              ID: 341,
            }
          },
          PHYSICAL_ACTIVITY: {
            ID: 369,
            URL: "physical-activity-summary",
            MODULE: {
              ID: 342,
            }
          }, 
          COPING_WITH_STRESS: {
            ID: 370,
            URL: "coping-with-stress-summary",
            MODULE: {
              ID: 344,
            }
          }
        }
      },
    },
    CARTOONS: {
      ID: 77,
      URL: 'cartoon',
      STEPS: {
        BACKSTORY: {
          ID: 345,
          URL: "backstory"
        },
        LESSON_6: {
          ID: 394,
        }
      }
    },
    TAILORED_FEEDBACK: {
      URL: 'tailored-feedback'
    },
    TEACHER_LOGBOOK: {
      URL: 'logbook'
    },
    TEACHER_EVALUATION: {
      URL: 'teacher-evaluation'
    },
    STUDENT_EVALUATION: {
      URL: 'student-evaluation'
    },
    SURVEY: {
      ID: 111,
      URL: 'evaluation',
      STUDENT: {
        ID: 453,
        URL: 'studentevaluation',
        MODULE: {
          ID: 130212,
          URL: 'program-student-evaluation'
        }
      },
      TEACHER: {
        ID: 452,
        URL: 'teacherevaluation',
        MODULE: {
          ID: 130214,
          URL: 'program-teacher-evaluation'
        },
      }
    }
  },
  GROUPS: {
    TEST: {
      ID: 9246
    }
  },
  USER_TYPE: {
    PARENT: {
      ID: 58
    },
    STUDENT: {
      ID: 59
    },
    TEACHER: {
      ID: 60
    }
  },
  URLS: {
    PRIVACY: {
      id: 'privacy',
      label: 'Privacy',
      href: '/privacy-policy',
    },
    TERMS: {
      id: 'terms-and-conditions',
      label: 'Terms & conditions',
      href: '/terms-and-conditions',
    },
  } as { [key: string]: IMenuItem },
  CONTENT_GROUP: {
    CARTOONS: {
      ID: 1468
    }
  },
  CUSTOM_FIELDS: {
    PHONE: {
      ID: 59
    },
    VIDEO_WATCHED: {
      ID: 285
    }
  },
  COOKIES: {
    MODULE_COMPLETE: 'module-completion',
    GOAL_COMPLETE: 'goal-completion',
    SPOTLIGHT: 'shouldShowSpotlight',
    PHONE_NUMBER: 'phoneNumber'
  },
  DIRECTORY: {
    SUPPORT_SERVICES: {
      PARENT: {
        ID: 34
      },
      STUDENT: {
        ID: 44
      }
    },
    RESOURCES: {
      PARENT: {
        ID: 35
      },
      STUDENT: {
        ID: 43
      },
      TEACHER: {
        ID: 57
      }
    },
  },
  ASSETS: {
    STANDARD_DRINK_CHART: {
      ID: "2b2eeea3-ba31-4618-a519-2e19aca39be4"
    },
    DIETARY_TEENAGERS: {
      ID: "0b247911-408a-4d98-a098-28ff37b3ac22"
    },
    DIETARY_ADULT: {
      ID: "913ca99c-be41-4f96-b36c-31d730d0c32b"
    },
    CHARACTERS_POSTER: {
      ID: "039ad391-3193-4e2d-bb49-6fde45e5e23c"
    }
  },
  EMAIL_TEMEPLATES: {
    SHARE_SUMMARY: {
      ID: 27205
    },
    INVITE_TEACHER: {
      ID: 29236
    }
  },
  TAGS: {
    STUDENT: {
      NAME: 'Student'
    },
    TEACHER: {
      NAME: 'Teacher'
    },
    LESSON_PDF: {
      NAME: 'Lesson-PDF'
    },
    LOGBOOK_PDF: {
      NAME: 'Logbook-PDF'
    },
  },
  STATIC_PAGE_REGENERATION_TIME_IN_SECONDS: 60,
};